import get from 'lodash.get';
export function createFulfilledReducer(statePath) {
  return (state, _ref) => {
    var {
      payload
    } = _ref;
    var asyncEntity = get(state, statePath);
    asyncEntity.initialized = true;
    asyncEntity.pending = false;
    asyncEntity.payload = payload;
    asyncEntity.error = null;
  };
}